import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const LoadMemberProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadMemberProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarHash"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorBlind"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"minutesBeforeDeadlineToNotify"}},{"kind":"Field","name":{"kind":"Name","value":"minutesBetweenSummaries"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateNext"}},{"kind":"Field","name":{"kind":"Name","value":"offsetCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"offsetNext"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twoFactor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"needsNewBackups"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"loginTypes"}},{"kind":"Field","name":{"kind":"Name","value":"logins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimable"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpires"}},{"kind":"Field","name":{"kind":"Name","value":"idMember"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idModel"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpires"}},{"kind":"Field","name":{"kind":"Name","value":"dateLastUsed"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"isRecent"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"LoadMemberProfile","document":LoadMemberProfileDocument}} as const;
export type LoadMemberProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type LoadMemberProfileQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'avatarSource' | 'avatarUrl' | 'fullName' | 'initials' | 'email' | 'username' | 'bio' | 'products' | 'loginTypes'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarHash' | 'avatarUrl' | 'initials' | 'fullName'>
    )>, prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'colorBlind' | 'locale' | 'minutesBeforeDeadlineToNotify' | 'minutesBetweenSummaries'>
      & { timezoneInfo: (
        { __typename: 'Member_Prefs_TimezoneInfo' }
        & Pick<Types.Member_Prefs_TimezoneInfo, 'dateNext' | 'offsetCurrent' | 'offsetNext' | 'timezoneCurrent' | 'timezoneNext'>
      ), twoFactor?: Types.Maybe<(
        { __typename: 'Member_Prefs_TwoFactor' }
        & Pick<Types.Member_Prefs_TwoFactor, 'enabled' | 'needsNewBackups'>
      )> }
    )>, logins: Array<(
      { __typename: 'Login' }
      & Pick<Types.Login, 'claimable' | 'email' | 'id' | 'primary' | 'types'>
    )>, tokens?: Types.Maybe<Array<Types.Maybe<(
      { __typename: 'Token' }
      & Pick<Types.Token, 'id' | 'dateCreated' | 'dateExpires' | 'idMember' | 'identifier'>
      & { permissions: Array<Types.Maybe<(
        { __typename: 'TokenPermission' }
        & Pick<Types.TokenPermission, 'idModel' | 'modelType' | 'read' | 'write'>
      )>> }
    )>>>, credentials: Array<(
      { __typename: 'Member_Credential' }
      & Pick<Types.Member_Credential, 'email' | 'id' | 'type'>
    )>, sessions: Array<(
      { __typename: 'Member_Session' }
      & Pick<Types.Member_Session, 'dateCreated' | 'dateExpires' | 'dateLastUsed' | 'id' | 'ipAddress' | 'isCurrent' | 'isRecent' | 'type' | 'userAgent'>
      & { data: (
        { __typename: 'Member_Session_Data' }
        & Pick<Types.Member_Session_Data, 'email'>
      ) }
    )> }
  )> }
);

/**
 * __useLoadMemberProfileQuery__
 *
 * To run a query within a React component, call `useLoadMemberProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMemberProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMemberProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadMemberProfileQuery(
  baseOptions: TrelloQueryHookOptions<
    LoadMemberProfileQuery,
    LoadMemberProfileQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: LoadMemberProfileDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    LoadMemberProfileQuery,
    LoadMemberProfileQueryVariables
  >(LoadMemberProfileDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useLoadMemberProfileLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    LoadMemberProfileQuery,
    LoadMemberProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadMemberProfileQuery,
    LoadMemberProfileQueryVariables
  >(LoadMemberProfileDocument, options);
}
export type LoadMemberProfileQueryHookResult = ReturnType<
  typeof useLoadMemberProfileQuery
>;
export type LoadMemberProfileLazyQueryHookResult = ReturnType<
  typeof useLoadMemberProfileLazyQuery
>;
export type LoadMemberProfileQueryResult = Apollo.QueryResult<
  LoadMemberProfileQuery,
  LoadMemberProfileQueryVariables
>;
